import { lazy, Suspense, useState, useEffect, useContext } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css'
import './styles/stylesheet.scss';
import { GlobalContext, GlobalProvider } from './context/GlobalContext';
import { loadConfig } from './configParser';
import Spinner from './pages/Spinner';
const Layout = lazy(() => import('./pages/Layout'));
const Login = lazy(() => import('./pages/Login'));
const Legal = lazy(() => import('./pages/Legal'));
const NoticeAccess = lazy(() => import('./pages/NoticeAccess'));
const ConfirmAccount = lazy(() => import('./pages/ConfirmAccount'));
const ConfirmAccount2 = lazy(() => import('./pages/ConfirmAccount2'));
const MasterCard = lazy(() => import('./pages/MasterCard'));
const Vote = lazy(() => import('./pages/Vote'));
const VoteConfirm = lazy(() => import('./pages/VoteConfirm'));
const ViewMaterialsOnline = lazy(() => import('./pages/ViewMaterials'));
const RequestMaterials = lazy(() => import('./pages/RequestMaterials'));
const SetDelivertPreferences = lazy(() => import('./pages/DeliveryPreferences'));
const Help = lazy(() => import('./pages/Help'));
const ContactUs = lazy(() => import('./pages/ContactUs'));
// import TermsConditions from './pages/TermsConditions';
import SessionTimeout from "./pages/SessionTimeout";

const WARNING_DURATION = 10;  // 10 seconds before logout

function LoadingOverlay() {
    return (
        <div style={{
            position: 'fixed',
            inset: 0,
            zIndex: 10000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'var(--app-surface-bg, #fff)',
        }}>
            <Spinner isLoading={true} />
        </div>
    );
}

function AppRoutes() {
    const { globalState } = useContext(GlobalContext);

    return (
        <Router basename={import.meta.env.BASE_URL}>
            <Suspense fallback={globalState.isAutoLoginInProgress ? null : <LoadingOverlay />}>
                <Routes>
                    {/* Layout route wraps all child routes */}
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Login />} />
                        <Route path="login" element={<Login />} />
                        <Route path="/pages/confirmAccount" element={<ConfirmAccount />} />
                        <Route path="/pages/confirmAccount2" element={<ConfirmAccount2 />} />
                        <Route path="/pages/masterCard" element={<MasterCard />} />
                        <Route path="/pages/legal" element={<Legal />} />
                        <Route path="/pages/noticeAccess" element={<NoticeAccess />} />
                        <Route path="/pages/vote" element={<Vote />} />
                        <Route path="/pages/voteConfirm" element={<VoteConfirm />} />
                        <Route path="/pages/help" element={<Help />} />
                        <Route path="/:alias" element={<ViewMaterialsOnline />} />
                        <Route path="/pages/requestMaterials" element={<RequestMaterials />} />
                        <Route path="/pages/deliveryPreferences" element={<SetDelivertPreferences />} />
                        <Route path="/pages/contactUs" element={<ContactUs />} />
                        {/* <Route path="/pages/termsConditions" element={<TermsConditions />} /> */}
                        <Route path="/pages/sessionTimeout" element={<SessionTimeout
                            timeout={WARNING_DURATION * 60000}
                            onTimeout={() => {
                                console.log("Session timed out");
                            }} />} />
                    </Route>
                </Routes>
            </Suspense>
            {globalState.isAutoLoginInProgress && (
                <LoadingOverlay />
            )}
        </Router>
    );
}

function App() {
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        async function initialize() {
            //log.info("initialize in App.jsx");
            const config = await loadConfig(); // Wait for the API base URL to be fetched
            window.serverUrl = config.serverUrl;
            //log.info("window.serverUrl: " + window.serverUrl);
            window.sessionTimeOutMilliSeconds = Number(config.sessionTimeOutMinutes * 60 * 1000);
            window.chatUrl = config.chatUrl;
            window.chatEnvironment = config.chatEnvironment;
            window.chatRegisteredDeploymentId = config.chatRegisteredDeploymentId;
            window.chatBeneficialDeploymentId = config.chatBeneficialDeploymentId;
            window.logoLocation = config.logoLocation;
            window.serverId = config.serverId;
            window.accountConfirmationAttemptsLimit = config.accountConfirmationAttemptsLimit;
            window.accountConfirmationAttemptsLimit2 = config.accountConfirmationAttemptsLimit2;
            window.captchaEnable = config.captchaEnable;
            window.votingSiteAppSecrectPublicKey = config.votingSiteAppSecrectPublicKey as string;
            window.votingSiteAppSecrectPrivateKey = config.votingSiteAppSecrectPrivateKey as string;
            setInitialized(true);
        }

        initialize(); // Call the initialization function
    }, []); // Runs only once after initial render

    if (!initialized) return <LoadingOverlay />; // the login.jsx code is running before above useEffect code, need to get serverUrl before getting service instance

    // multiple providers are allowed, nest them
    // for PRD, the base name is set to /VotingSiteApp, so that the app can be deployed under a subdirectory
    return (
        <GlobalProvider>
            <AppRoutes />
        </GlobalProvider>
    )
}

export default App
